/* FAQ page tabs (desktop pills) / accordion (mobile). window.openTerms is the legacy global the
   inline onclick handlers call (kept for the iOS app scraper contract). */
(() => {
  const mobile = () => !matchMedia('(min-width: 750px)').matches;

  function openTerms(evt, id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    const root = panel.closest('.content-desktop') || document;
    const btn = (evt && evt.currentTarget) || root.querySelector(`[aria-controls="${id}"]`);
    const wasOpen = btn && btn.getAttribute('aria-expanded') === 'true';
    const collapse = wasOpen && mobile();
    root.querySelectorAll('.tablinks').forEach((b) => {
      const on = !collapse && b.getAttribute('aria-controls') === id;
      b.classList.toggle('active', on);
      b.setAttribute('aria-expanded', String(on));
    });
    const slide = mobile() && evt && window.Theme?.slide;
    root.querySelectorAll('.tabcontent').forEach((p) => {
      const show = !collapse && p.id === id;
      if (slide && p.hidden === show) window.Theme.slide(p, show); /* mobile accordion: smooth open/close */
      else p.hidden = !show;
    });
    if (!collapse && evt && mobile() && btn) {
      const top = btn.getBoundingClientRect().top;
      if (top < 0 || top > innerHeight * 0.6) btn.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (evt && !collapse && history.replaceState) history.replaceState(null, '', `#${id}`);
  }
  window.openTerms = openTerms;

  const fromHash = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (id && document.querySelector(`.content-desktop .tabcontent#${CSS.escape(id)}`)) openTerms(null, id);
  };
  fromHash();
  addEventListener('hashchange', fromHash);
})();

/* Questions as accordions + search. Runs on the rendered page only: the server HTML (one rich-text body
   per tab, "<p><strong>- Question?</strong></p><p>Answer</p>…") stays exactly as the iOS app parses it. */
(() => {
  const root = document.querySelector('[data-faq]');
  if (!root) return;
  const panels = [...root.querySelectorAll('.tabcontent')];
  const plainQ = (el) => {
    const t = (el.textContent || '').replace(/ /g, ' ').trim();
    const strong = el.querySelector('strong, b');
    if (!strong || (strong.textContent || '').trim().length < t.length - 2) return '';
    return t.replace(/^[-–•]\s*/, '');
  };
  panels.forEach((panel) => {
    const tab = root.querySelector(`[aria-controls="${panel.id}"]`);
    if (tab) panel.dataset.cat = tab.textContent.trim();
    const nodes = [...panel.childNodes];
    const frag = document.createDocumentFragment();
    let cur = null;
    nodes.forEach((n) => {
      if (n.nodeType === 3 && !n.textContent.trim()) return;
      if (n.nodeType === 1 && n.matches('p') && !n.textContent.replace(/ /g, ' ').trim() && !n.querySelector('img')) return; // empty spacer
      const q = n.nodeType === 1 && n.matches('p, h3, h4') ? plainQ(n) : '';
      if (q && q.includes('?')) {
        cur = document.createElement('details');
        cur.className = 'faq-q';
        const sum = document.createElement('summary');
        sum.className = 'faq-q__q';
        sum.textContent = q;
        const a = document.createElement('div');
        a.className = 'faq-q__a';
        cur.append(sum, a);
        frag.append(cur);
        return;
      }
      if (q && !cur) { n.classList.add('faq-q__cat'); frag.append(n); return; } // category label ("PRODUCT")
      if (cur) cur.lastChild.append(n); else frag.append(n);
    });
    if (!panel.querySelector('details') && frag.querySelector('details')) { panel.textContent = ''; panel.append(frag); panel.classList.add('is-enhanced'); }
  });

  const box = root.querySelector('[data-faq-search]');
  const input = root.querySelector('[data-faq-search-input]');
  const clear = root.querySelector('[data-faq-search-clear]');
  const empty = root.querySelector('[data-faq-empty]');
  if (!box || !input || !root.querySelector('.faq-q')) return;
  box.hidden = false;
  const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  let saved = null;
  const run = () => {
    const q = norm(input.value.trim());
    clear.hidden = !q;
    if (q.length < 2) {
      if (saved) {
        root.classList.remove('is-searching');
        panels.forEach((p) => { p.hidden = p.id !== saved; p.querySelectorAll('.faq-q').forEach((d) => { d.hidden = false; d.open = false; }); });
        saved = null;
      }
      empty.hidden = true;
      return;
    }
    if (!saved) saved = (panels.find((p) => !p.hidden) || panels[0]).id;
    root.classList.add('is-searching');
    let hits = 0;
    panels.forEach((p) => {
      let n = 0;
      p.querySelectorAll('.faq-q').forEach((d) => {
        const ok = norm(d.textContent).includes(q);
        d.hidden = !ok; d.open = ok;
        if (ok) n++;
      });
      p.hidden = n === 0;
      hits += n;
    });
    empty.hidden = hits > 0;
  };
  input.addEventListener('input', run);
  clear.addEventListener('click', () => { input.value = ''; run(); input.focus(); });

  /* ?faq=<question> (the site search's answers link here): that question open and in view, the others hidden
     behind the search box until it is cleared */
  const asked = new URL(location.href).searchParams.get('faq');
  if (asked) {
    const want = norm(asked).replace(/[^a-z0-9]+/g, ' ').trim();
    const qs = [...root.querySelectorAll('.faq-q')];
    const hit = qs.find((d) => norm(d.querySelector('summary').textContent).replace(/[^a-z0-9]+/g, ' ').trim().startsWith(want.slice(0, 60)));
    if (hit) {
      input.value = hit.querySelector('summary').textContent.trim();
      run();
      requestAnimationFrame(() => hit.scrollIntoView({ block: 'center', behavior: 'auto' }));
    }
  }
})();
